import React from "react";

function SolutionsSection() {
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 700;
  const isTablet = typeof window !== 'undefined' && window.innerWidth <= 1024;
  return (
    <section className="section solutions-section" id="solutions" style={{ padding: isMobile ? '32px 0' : undefined }}>
      <div className="container" style={{ padding: isMobile ? '0 8px' : undefined }}>
        <div className="section-header" data-aos="fade-up" style={{ textAlign: isMobile ? 'center' : undefined }}>
          <span className="section-subtitle" style={{ fontSize: isMobile ? '1rem' : undefined }}>Our Expertise</span>
          <h2 style={{ fontSize: isMobile ? '1.4rem' : undefined, marginBottom: isMobile ? 8 : undefined }}>Enterprise-Grade Streaming Solutions</h2>
          <p className="section-description" style={{ fontSize: isMobile ? '1rem' : undefined, marginBottom: isMobile ? 18 : undefined }}>
            Delivering production-ready streaming architectures that power
            real-time business decisions
          </p>
        </div>

        <div className="solutions-container" style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          flexWrap: isMobile ? 'nowrap' : 'wrap',
          gap: isMobile ? 18 : 32,
          margin: isMobile ? '0 auto' : undefined,
          alignItems: isMobile ? 'stretch' : 'flex-start',
        }}>
          {/* Solution 1 */}
          <div className="solution-card" data-aos="fade-up" data-aos-delay="100" style={{
            width: isMobile ? '100%' :  'calc(25% - 24px)',
            minWidth: isMobile ? 0 : 260,
            maxWidth: isMobile ? '100%' : 340,
            margin: isMobile ? '0 auto' : undefined,
            padding: isMobile ? '18px 10px' : undefined,
            borderRadius: isMobile ? 12 : undefined,
            fontSize: isMobile ? '0.97rem' : undefined,
          }}>
            <div className="solution-icon">
              <i className="fas fa-network-wired"></i>
            </div>
            <h3>Real-Time Data Fabric</h3>
            <p>
              Unified event streaming backbone using Confluent Platform /
              Confluent Cloud. Ingest once, publish everywhere: core banking,
              payments, channels, fraud, compliance, analytics, SIEM.
            </p>
            <ul className="solution-features">
              <li>
                <i className="fas fa-check"></i> High-throughput, low-latency
                data pipelines
              </li>
              <li>
                <i className="fas fa-check"></i> Exactly-once processing
                semantics
              </li>
              <li>
                <i className="fas fa-check"></i> Multi-datacenter replication
              </li>
            </ul>
            <a href="#contact" className="solution-link">
              Learn more <i className="fas fa-arrow-right"></i>
            </a>
          </div>

          {/* Solution 2 */}
          <div className="solution-card" data-aos="fade-up" data-aos-delay="150" style={{
            width: isMobile ? '100%' :  'calc(25% - 24px)',
            minWidth: isMobile ? 0 : 260,
            maxWidth: isMobile ? '100%' : 340,
            margin: isMobile ? '0 auto' : undefined,
            padding: isMobile ? '18px 10px' : undefined,
            borderRadius: isMobile ? 12 : undefined,
            fontSize: isMobile ? '0.97rem' : undefined,
          }}>
            <div className="solution-icon">
              <i className="fas fa-shield-alt"></i>
            </div>
            <h3>Security &amp; SIEM Integration</h3>
            <p>
              Stream high-value security telemetry into your SIEM in real time.
              Normalize, enrich, and correlate before ingestion to reduce costs
              and noise.
            </p>
            <ul className="solution-features">
              <li>
                <i className="fas fa-check"></i> Pre-built SIEM connectors
                (Splunk, IBM QRadar, etc.)
              </li>
              <li>
                <i className="fas fa-check"></i> Threat intelligence enrichment
              </li>
              <li>
                <i className="fas fa-check"></i> Regulatory-compliant logging
              </li>
            </ul>
            <a href="#siem" className="solution-link">
              Explore SIEM solutions <i className="fas fa-arrow-right"></i>
            </a>
          </div>

          {/* Solution 3 */}
          <div className="solution-card" data-aos="fade-up" data-aos-delay="200" style={{
            width: isMobile ? '100%' :  'calc(25% - 24px)',
            minWidth: isMobile ? 0 : 260,
            maxWidth: isMobile ? '100%' : 340,
            margin: isMobile ? '0 auto' : undefined,
            padding: isMobile ? '18px 10px' : undefined,
            borderRadius: isMobile ? 12 : undefined,
            fontSize: isMobile ? '0.97rem' : undefined,
          }}>
            <div className="solution-icon">
              <i className="fas fa-balance-scale"></i>
            </div>
            <h3>Governed Data Streaming</h3>
            <p>
              Enterprise-grade data governance for your streaming platform.
              Ensure compliance, security, and data quality across all your
              real-time data flows.
            </p>
            <ul className="solution-features">
              <li>
                <i className="fas fa-check"></i> Schema Registry &amp; Evolution
              </li>
              <li>
                <i className="fas fa-check"></i> Role-based access controls
              </li>
              <li>
                <i className="fas fa-check"></i> Data lineage &amp; audit trails
              </li>
            </ul>
            <a href="#governance" className="solution-link">
              Governance details <i className="fas fa-arrow-right"></i>
            </a>
          </div>

          {/* Solution 4 */}
          <div className="solution-card" data-aos="fade-up" data-aos-delay="250" style={{
            width: isMobile ? '100%' :  'calc(25% - 24px)',
            minWidth: isMobile ? 0 : 260,
            maxWidth: isMobile ? '100%' : 340,
            margin: isMobile ? '0 auto' : undefined,
            padding: isMobile ? '18px 10px' : undefined,
            borderRadius: isMobile ? 12 : undefined,
            fontSize: isMobile ? '0.97rem' : undefined,
          }}>
            <div className="solution-icon">
              <i className="fas fa-headset"></i>
            </div>
            <h3>Managed Services</h3>
            <p>
              End-to-end management of your Confluent deployment. Focus on your
              business while we handle the infrastructure.
            </p>
            <ul className="solution-features">
              <li>
                <i className="fas fa-check"></i> 24/7 monitoring &amp; support
              </li>
              <li>
                <i className="fas fa-check"></i> Performance optimization
              </li>
              <li>
                <i className="fas fa-check"></i> Security patching &amp;
                upgrades
              </li>
            </ul>
            <a href="#contact" className="solution-link">
              Managed services info <i className="fas fa-arrow-right"></i>
            </a>
          </div>
        </div>

        <div className="solutions-cta" data-aos="fade-up" style={{
          marginTop: isMobile ? 32 : undefined,
          padding: isMobile ? '18px 8px' : undefined,
          borderRadius: isMobile ? 10 : undefined,
          textAlign: isMobile ? 'center' : undefined,
        }}>
          <h3 style={{ fontSize: isMobile ? '1.1rem' : undefined, marginBottom: isMobile ? 8 : undefined }}>Ready to transform your data strategy?</h3>
          <p style={{ fontSize: isMobile ? '0.97rem' : undefined, marginBottom: isMobile ? 12 : undefined }}>
            Our experts are ready to help you design and implement a
            streaming platform tailored to your needs.
          </p>
          <a 
            href="/contact" 
            className="btn btn-primary"
            style={{ 
              cursor: 'pointer',
              pointerEvents: 'auto',
              fontSize: isMobile ? '1rem' : undefined,
              padding: isMobile ? '12px 18px' : undefined,
              borderRadius: isMobile ? 8 : undefined,
              width: isMobile ? '100%' : undefined,
              maxWidth: isMobile ? 320 : undefined,
              margin: isMobile ? '0 auto' : undefined,
              display: isMobile ? 'block' : undefined,
            }}
          >
            Request Architecture Review
          </a>
        </div>
      </div>
    </section>
  );
}

export default SolutionsSection;
